import './CSS/App.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import Health from './Pages/Health';
import { NotFound } from './Pages/NotFound';
import LearningObjects from './Pages/LearningObject';
import HotSpotCustomElement from './Pages/CustomElement-HotSpot';
import DebugToolsProvider from './Components/DebugToolsProvider';
import { OIDCDebugPanel } from './Components/Debug/OIDCDebugPanel';
import { FEATURE_FLAGS } from './Utilities/FeatureFlags';

/**
 * Main application component
 * Sets up routes and conditionally enables debug tools
 */
const App = () => {
  // Check if debug panel should be shown based on feature flags
  // - Feature flag controls base visibility (build-time configuration)
  // - URL parameter ?debug=true allows IT support override
  // - NOT shown by default for business users in production
  const urlParams = new URLSearchParams(window.location.search);
  const debugRequested = urlParams.get('debug') === 'true';

  // Use feature flag for base visibility, allow IT support override
  const showDebugPanel = FEATURE_FLAGS.ALLOW_OIDC_DEBUG || debugRequested;

  return (
    <>
      {/* Conditionally enable debug tools based on feature flags */}
      <DebugToolsProvider />

      {/* OIDC Debug Panel - Only for IT support or development */}
      {showDebugPanel && (
        <OIDCDebugPanel
          defaultExpanded={debugRequested}
          showInProduction={true}
        />
      )}

      {/* <Metadata /> */}
      <Routes>
        <Route
          path="/learningobject/:learningObjectSlug"
          element={<LearningObjects />}
        />
        <Route
          path="/customelement-hotspot/"
          element={<HotSpotCustomElement />}
        />
        <Route path="/health" element={<Health />} />

        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
      {/* <Footer /> */}
    </>
  );
};

export default App;
